import { render, staticRenderFns } from "./AdvisoryFunds.vue?vue&type=template&id=c52fbf10&scoped=true"
import script from "./AdvisoryFunds.vue?vue&type=script&lang=ts"
export * from "./AdvisoryFunds.vue?vue&type=script&lang=ts"
import style0 from "./AdvisoryFunds.vue?vue&type=style&index=0&id=c52fbf10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52fbf10",
  null
  
)

export default component.exports